/* eslint-disable import/no-named-as-default-member */
import React from 'react';
import PropTypes from 'prop-types';

import './NameTag.css';
import handleCharacterEncoding from '../../../handleCharacterEncoding';
import AddToMyList from './AddToMyList';

function NameTag(props) {
  const { daten, viewportWidth } = props;
  return (
    <div
      className={
          viewportWidth > 768 ? 'name-tag-projekt' : 'name-tag-projekt-mobil'
        }
      style={{ display: 'flex' }}
    >
      {' '}
      <h3
        className={
            viewportWidth > 768 ? 'name-tag-schrift' : 'name-tag-schrift-mobil'
          }
      >
        {handleCharacterEncoding(daten[0].projekt_titel)}
      </h3>
      <div
        className="like-button"
        style={{
          display: 'flex',
        }}
      >
        <AddToMyList daten={daten[0].projekt_ID} />
      </div>
    </div>
  );
}

export default NameTag;

NameTag.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  daten: PropTypes.array.isRequired,
  viewportWidth: PropTypes.number.isRequired,
};
